// ControlPictureFactory.js
import $ from 'jquery';

import BaseVisualControlFactory	from 'BaseVisualControlFactory.js';
import factoryService   from 'FactoryService.js';
import constants        from 'Constants.js';
import sequenceService  from 'SequenceService.js';

import ControlModel    from 'ControlModel.js';
import PictureControlView from 'common-visuals/PictureControlView.js';
import dummypic 		from 'dummypic.png';

//=============================================================================
//
// Creates an image ref container, given a factoryService
// parameter key and a layout postion. The factory key defines the initial
// rectangle of the control via a width and height from the factory parameter.
//
// -Lou Mauget, December 8, 2015 
//
//=============================================================================
class ControlPictureFactory extends BaseVisualControlFactory {
	constructor () {
		super();
	}

	createView( factoryKey, pos ) {

  		const attributes = this.createChildAttributes(  factoryKey, pos ) ;
  		attributes.picture = dummypic;
		attributes.maintainAspectRatio = true;
		attributes.preloadImage = true;
		attributes.stretch = true;
		attributes.pictureStyle = '';
		attributes.assetId= 'none';
        attributes.resizePadding = 2;
		attributes.minWidth = 10;
		attributes.minHeight = 10;
		attributes.naturalWidth = 1;
		attributes.naturalHeight = 1;
		attributes.printQuality = 'regular';
		attributes.translateProps = [
            {key:"toolTip", label:"Tooltip"},
            {key:"accessDesc", label:"Accessibility Description"}
        ];

        return new PictureControlView( { model: new ControlModel( attributes ), el: $(constants.FORM_ID),  
            							pos: pos, factoryKey: factoryKey, id: attributes.id } );
	}

}

const controlPictureFactory = new ControlPictureFactory();

export default controlPictureFactory;
